// extracted by mini-css-extract-plugin
module.exports = {"header":"MarketplaceBills_header_2G4t0","loader":"MarketplaceBills_loader_244R1"};